const messages = {
  title: "Primljena pošta",
  desc: "Ovdje ćete pronaći važne obavijesti i vijesti.",
  newMessages: "Nove poruke u primljenoj pošti",
  link: "Prikažite poruke",
  showMessages: "Prikažite poruke",
  message: {
    sender: "Pošiljatelj",
    thread: "Predmet",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Natrag",
  time: {
    secondsAgo: "prije {time} sekundi",
    minutesAgo: "prije {time} minuta",
    hoursAgo: "prije {time} sati",
    daysAgo: "prije {time} dana",
  },
};
export default {
  messages,
};
